import { render, staticRenderFns } from "./Union.vue?vue&type=template&id=2cc6e02e&scoped=true"
import script from "./Union.vue?vue&type=script&lang=js"
export * from "./Union.vue?vue&type=script&lang=js"
import style0 from "./Union.vue?vue&type=style&index=0&id=2cc6e02e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc6e02e",
  null
  
)

export default component.exports